import styled from '@emotion/styled';
import rem from '../../../../utils/rem/rem';

export const StyledReviewChanges = styled.div`
  padding: 0 ${rem(32)};
`;

export const Buttons = styled.div`
  display: flex;
  justify-content: space-between;
  padding-top: ${rem(16)};
`;
